// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"457c065f","346":"cc00fa56","577":"4dbfd1b8","950":"9e962f7a","981":"a4007acd"}[chunkId] + ".chunk.css";
};